import { FunctionComponent, useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAppStore } from '../../stores/application/useAppStore'
import { AppRoutes } from '../../interfaces/store/appStore'

interface IOnboardingPageProps {}

const OnboardingPage: FunctionComponent<IOnboardingPageProps> = () => {
    const { store: { onboardingStep } } = useAppStore()
    const navigate = useNavigate()
    const location = useLocation()

    const isOnboardingChildRoute =
        location.pathname === AppRoutes.ONBOARDING_EXTENSION_INSTALL ||
        location.pathname === AppRoutes.ONBOARDING_UNSUPPORTED_BROWSER ||
        location.pathname === AppRoutes.ONBOARDING_LINKEDIN ||
        location.pathname === AppRoutes.ONBOARDING_SYNC_NETWORK ||
        location.pathname === AppRoutes.ONBOARDING_SURVEY ||
        location.pathname === AppRoutes.ONBOARDING_ALL_SET ||
        location.pathname === AppRoutes.ONBOARDING_MOBILE_FINISH

    useEffect(() => {
        if (onboardingStep < 0 && !isOnboardingChildRoute) {
            navigate(AppRoutes.HOME)
        }
    }, [onboardingStep, navigate, isOnboardingChildRoute])

    return <Outlet />
}

export default OnboardingPage
